/**
 * Access denied page shown when a user lacks permission for a route.
 */

export function AccessDenied(): React.JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        gap: '16px',
      }}
    >
      <h1 style={{ color: 'var(--text1)', margin: 0 }}>Access restricted</h1>
      <p style={{ color: 'var(--text2)', margin: 0 }}>
        Your role does not have permission to view this page.
      </p>
    </div>
  );
}
